import React, { useState } from "react";
import './App.css';
import Sidebar from './components/common/Sidebar/Sidebar';
import Topbar from './components/common/Topbar/Topbar';
import ROUTES, { getRoutes, RenderRoutes } from "./router/routes";

function App() {
  const [isActiveNav, setIsActiveNav] = useState(false);
  const handleToggleActive = () => {
    setIsActiveNav(isActiveNav => !isActiveNav)
  };

  return (
    <>
      <Topbar isActive={isActiveNav} handleToggleActive={handleToggleActive} />
      <Sidebar isActive={isActiveNav} handleToggleActive={handleToggleActive} />
      <main className="pl-sidebarClosedWidth pb-20 pt-topbarHeight">
        {/* <div className="theme-container"> */}
        <div className="px-6 md:px-12">
          <RenderRoutes routes={getRoutes()} />
          <div>
            {/* <Users /> */}
          </div>
        </div>
      </main>
      {/* <Login /> */}
    </>
  );
}

export default App;
